module.exports = {
  "report": {
    "evaluationReport": "测评报告",
    "evaluationUser": "测评用户",
    "evaluationResults": "测评结果",
    "evaluationScore": "测评分数",
    "riskLevel": "预警等级",
    "greenWarning": "绿色预警",
    "yellowWarning": "黄色预警",
    "orangeWarning": "橙色预警",
    "redWarning": "红色预警",
    "scoreRange": "得分范围",
    "evaluationResults2": "评定结果",
    "resultDescription": "结果描述",
    "interventionPlan": "建议",
    "factorAnalysis": "因子分析",
    "reportList": "我的报告",
    "evalutaionScale": "测评量表",
    "judgmentRulesOption7": "大于",
    "judgmentRulesOption8": "小于",
    "judgmentRulesOption9": "等于",
    "judgmentRulesOption10": "大于等于",
    "judgmentRulesOption11": "小于等于",
    "judgmentRulesOption12": "不等于",
    "standard": "评定标准",
    "evaluationScore2": "测评得分",
    "zhcpjg": "综合测评结果",
    "zhcpjgText1": "心理健康",
    "zhcpjgText2": "轻度心理问题",
    "zhcpjgText3": "中度心理问题",
    "zhcpjgText4": "重度心理问题",
    "zhcpjgText5": "严重心理问题",
    "zhcpjgDescription1": "学生没有表现出影响学习和生活的心理良好的状态。",
    "zhcpjgDescription2": "表示预警程度较低，意味着学生可能存在一些轻微的心理问题或情绪波动，但尚未达到严重程度。",
    "zhcpjgDescription3": "表示预警程度中等，意味着学生的心理问题已经较为显著，需要及时关注和干预。",
    "zhcpjgDescription4": "表示警报程度较高，意味着学生的心理问题已经比较严重，显著地影响到了学生的日常生活，需要立即采取行动进行干预和处理。",
    "zhcpjgDescription5": "表示极度危险的情况，可能指学生面临极端严重的心理问题、生命危险或严重的暴力行为，需要立即采取紧急措施。",
    "zhyzfx": "综合因子分析",
    "factorReport": "因子报告",
    "crisisReport": "危机报告",
    "labelRemark": "因子描述",
    "testContent": "测评内容",
    "testDesc": "测评结果说明",
    viewReport: "查看报告",
    difficultyDetail: '困难详情'
  },
}



// WEBPACK FOOTER //
// ./src/i18n/report/zh-CN.js